import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  NumberInput,
  TextInput,
  Textarea,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMDeliverPriority } from "../../../../model/TblDMDeliverPriority";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { useEffect } from "react";
import { handleKeyDown } from "../../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../../const/variables";

const CreateDataView = ({ onClose }: CreateDataViewProps) => {
  const entity = {
    id: "0",
    name: "",
    code: "",
    active: false,
    note: null,
    deliveryTime: 0,
    createBy: null,
    createDate: null,
    lastUpdateBy: null,
    lastUpdateDate: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<TblDMDeliverPriority>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      name: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên mức độ ưu tiên giao hàng!";
        }
        return hasLength(
          { min: 5, max: 256 },
          "Tên phải từ 5-256 kí tự!"
        )(value as string);
      },
      code: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập mã mức độ ưu tiên giao hàng!";
        }
        return hasLength(
          { max: 50 },
          "Mã phải nhỏ hơn 50 kí tự!"
        )(value as string);
      },
      deliveryTime: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập khoảng thời gian giao hàng!";
        }
      },
      note: (value: string | null) => {
        if (value) {
          return hasLength(
            { max: 250 },
            "Ghi chú phải nhỏ hơn 250 kí tự!"
          )(value as string);
        }
      },
    },
  });

  const callApiGetData = async () => {
    open();
    const callApi = await repositoryMdm.get<
      MessageResponse<TblDMDeliverPriority>
    >("/api/v1/TblDmDeliverPriority/create");
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Bạn không có quyền tạo!!!");
      modals.closeAll();
    }
  };

  const handleCreateTblDMDeliverPriority = async (
    dataSubmit: TblDMDeliverPriority
  ) => {
    open();
    const dataApi = await repositoryMdm.post<
      MessageResponse<TblDMDeliverPriority>
    >("/api/v1/TblDMDeliverPriority/create", dataSubmit);
    if (dataApi?.success) {
      onClose((prev: any) => !prev);

      modals.closeAll();
      NotificationExtension.Success("Thêm thành công !");
    }
    close();
  };

  useEffect(() => {
    callApiGetData();
  }, []);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: TblDMDeliverPriority) => {
          handleCreateTblDMDeliverPriority(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={6}>
            <TextInput
              label={"Mã mức độ ưu tiên giao hàng"}
              placeholder={"Nhập mã mức độ ưu tiên giao hàng"}
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("code")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label={"Tên mức độ ưu tiên giao hàng"}
              placeholder={"Nhập tên mức độ ưu tiên giao hàng"}
              withAsterisk
              w={"100%"}
              {...form.getInputProps("name")}
            />
          </Grid.Col>
        </Grid>

        <Grid align="center" pos={"relative"}>
          <Grid.Col span={12}>
            <NumberInput
              hideControls
              min={0}
              label={"Khoảng thời gian giao hàng"}
              placeholder={"Giờ"}
              withAsterisk
              {...form.getInputProps("deliveryTime")}
            />
          </Grid.Col>
        </Grid>

        <Grid grow align="center">
          <Grid.Col span={12}>
            <Textarea
              label={"Ghi chú"}
              placeholder="Nhập ghi chú"
              {...form.getInputProps("note")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox label={"Sử dụng"} {...form.getInputProps("active")} />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default CreateDataView;

type CreateDataViewProps = {
  onClose: any;
};
